import { j as i } from "./index58.mjs";
import { Divider as t } from "@mantine/core";
const o = (e) => {
  let r = `border-dark-400 border-opacity-20 ${e.className}`;
  return e.orientation === "vertical" ? r = `${r} mx-1 my-auto` : r = `${r} mx-auto`, /* @__PURE__ */ i.jsx(
    t,
    {
      style: { margin: "1rem 0" },
      ...e,
      className: r
    }
  );
};
export {
  o as Divider
};
